module.exports = __webpack_public_path__ + "static/media/ic-star-holo.794639d0.svg";